import create from "zustand";
import { persist } from "zustand/middleware";

const store = (set) => ({
  rightSideBar: true,
  setRightSideBar: (rightSideBar) => set({ rightSideBar }),
});

const configStore = create(persist(store));

export default configStore;
